/* eslint-disable @typescript-eslint/no-explicit-any */
import { readFunctionMapping } from '../../../helper';
import { invokeLambda } from './lambdaInvoke';
import {
    IFunctionGateway,
    IFunctionMapping,
    IFunctionMappingLambda,
} from '../../../interfaces';

export class LambdaGatewayService implements IFunctionGateway {
    invoke(
        functionName: string,
        params: unknown,
        fnMapping: IFunctionMapping,
    ): Promise<any> {
        const lambdaConfig = readFunctionMapping(
            functionName,
            fnMapping,
            params,
            'lambda',
        ) as IFunctionMappingLambda;

        return invokeLambda(
            lambdaConfig.name,
            lambdaConfig.payload,
            lambdaConfig.options,
            lambdaConfig.callback,
        );
    }
}
